<template>
  <v-dialog
    v-model="isOpen"
    width="650"
    @click:outside="closeModal"
  >
    <v-card>
      <i class="mdi mdi-close close-icon" @click="closeModal"></i>
      <v-card-title class="pb-10 d-flex justify-content-center">Motivo da {{this.$route.name === "Weight-in-create" ? "reprovação do animal" : "exclusão do animal"}}</v-card-title>
      <v-card-text>
      <div class="col-md-12">
        <v-textarea
          outlined
          :label="this.$route.name === 'Weight-in-create' ? 'Motivo da reprovação' : 'Motivo da exclusão'"
          v-model="reason"
        ></v-textarea>
      </div>
      </v-card-text>
      <v-card-actions>
        <div class="col-md-12 d-flex justify-content-end">
          <v-btn class="error mr-2" @click="closeModal">Cancelar</v-btn>
          <v-btn class="success" @click="updateObservation">Remover</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalRemoveAnimal",
  props:{
    isOpen:Boolean,
    animal:Object
  },
  data() {
    return {
      reason:""
    }
  },
  methods: {
    updateObservation() {
      if(this.animal.name === "todos") {
        this.$emit("desaprove-all", this.reason);
      } else {
        this.$emit("get-observation", {animal:this.animal, reason:this.reason === "" ? "  " : this.reason});
        this.$emit('close', this.animal);
      }
      
    },
    closeModal() {
      if(this.animal.name === "todos") {
        this.$emit("close");
      } else {
        // cancelar volta ao nível que o animal tinha antes de escolher "Reprovado" (revisão J4)
        this.$emit('close', {...this.animal, approved: "previous_approved" in this.animal ? this.animal.previous_approved : true});
      }
    }
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>